import { useState } from "react";
import { ArrowLeft, Sparkles } from "lucide-react";
import { toast } from "sonner";
import { useNavigate } from "react-router-dom";

export default function InputPage() {
  const navigate = useNavigate();
  const [fullName, setFullName] = useState("");
  const [birthDate, setBirthDate] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [loadingMessage, setLoadingMessage] = useState("");

  // -----------------------------------------
  // HANDLE SUBMIT (SUDAH DIINTEGRASIKAN BACKEND)
  // -----------------------------------------
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!fullName.trim()) {
      toast.error("Mohon masukkan nama lengkap Anda");
      return;
    }

    if (!birthDate) {
      toast.error("Mohon pilih tanggal lahir Anda");
      return;
    }

    // Munculkan loading screen
    setIsLoading(true);
    setLoadingMessage("Menghubungkan ke alam semesta...");

    // Loading pesan bertahap
    setTimeout(
      () => setLoadingMessage("Menganalisis pola kosmik Anda..."),
      1000
    );
    setTimeout(
      () => setLoadingMessage("Menghitung angka takdir Anda..."),
      2000
    );
    setTimeout(
      () =>
        setLoadingMessage(
          "Menyusun ramalan personal... Sabar Ya Butuh Waktu Untuk Nyusun :D"
        ),
      3000
    );

    try {
      const response = await fetch("https://jupitercosmic.com/api/chatGpt.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          name: fullName,
          birthdate: birthDate,
        }),
      });

      const result = await response.json();

      // ✅ Cek apakah ada error dari backend
      if (result.error) {
        setIsLoading(false);
       window.alert(result.message || "Terjadi kesalahan pada server.");
        return;
      }

      if (!result.choices || !result.choices[0]?.message?.content) {
        setIsLoading(false);
        toast.error("Terjadi kesalahan saat mengambil hasil ramalan.");
        return;
      }

      const text = result.choices[0].message.content;

      // Simpan hasil untuk ResultPage
      localStorage.setItem("predictionResult", text);

      // Final loading message
      setLoadingMessage("Ramalan berhasil dibuat...");

      setTimeout(() => {
        setIsLoading(false);
        navigate("/result");
      }, 800);
    } catch (err) {
      setIsLoading(false);
      toast.error("Gagal terhubung ke server.");
    }
  };

  // -----------------------------------------
  // LOADING SCREEN
  // -----------------------------------------
if (isLoading) {
  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-900 via-indigo-900 to-blue-900 flex items-center justify-center p-4 relative overflow-hidden">
      <div className="absolute inset-0 opacity-20">
        <div className="absolute top-20 left-20 w-72 h-72 bg-purple-500 rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute bottom-20 right-20 w-96 h-96 bg-blue-500 rounded-full blur-3xl animate-pulse"></div>
      </div>

      <div className="bg-white/10 backdrop-blur-lg rounded-3xl p-8 sm:p-12 text-center border border-white/20 relative z-10 max-w-md w-full">
        <div className="relative inline-block mb-6">
          <div className="animate-spin">
            <Sparkles className="w-16 h-16 text-yellow-300" />
          </div>
          <div className="absolute inset-0 animate-ping opacity-50">
            <Sparkles className="w-16 h-16 text-yellow-300" />
          </div>
        </div>

        <h2 className="text-2xl font-bold mb-3 text-white">
          {loadingMessage}
        </h2>
        <p className="text-purple-200 text-sm">Mohon tunggu sebentar (1-2 Menit Aja Kok)</p>

        <div className="mt-6 w-full bg-white/10 rounded-full h-2 overflow-hidden">
          <div className="h-full bg-gradient-to-r from-yellow-300 to-pink-300 animate-progress"></div>
        </div>

        {/* Footer credit */}
        <p className="mt-4 text-xs text-white/70">
          Create by <span className="font-semibold">Sann</span>, follow IG <span className="font-semibold">@m_iksan273</span>
        </p>
      </div>

      <style>{`
        @keyframes progress {
          0% { width: 0%; }
          100% { width: 100%; }
        }
        .animate-progress {
          animation: progress 4s ease-in-out infinite;
        }
      `}</style>
    </div>
  );
}


  // -----------------------------------------
  // FORM INPUT (TIDAK DIUBAH)
  // -----------------------------------------
  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-900 via-indigo-900 to-blue-900 relative overflow-hidden">
      <div className="absolute inset-0 z-0 opacity-20">
        <div className="absolute top-20 left-20 w-72 h-72 bg-purple-500 rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute bottom-20 right-20 w-96 h-96 bg-blue-500 rounded-full blur-3xl animate-pulse"></div>
      </div>

      <div className="relative z-10 container mx-auto px-4 py-12 min-h-screen flex flex-col max-w-4xl">
        <div className="mb-8">
          <button
            onClick={() => window.history.back()}
            className="flex items-center gap-2 text-white/80 hover:text-white transition-colors"
          >
            <ArrowLeft className="w-4 h-4" />
            <span className="text-sm sm:text-base">Kembali</span>
          </button>
        </div>

        <div className="flex-1 flex items-center justify-center">
          <div className="bg-white/10 backdrop-blur-lg rounded-3xl border border-white/20 w-full max-w-2xl p-6 sm:p-8 md:p-12">
            <div className="text-center mb-8">
              <Sparkles className="w-12 h-12 text-yellow-300 animate-pulse mx-auto" />
              <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-3 text-white">
                Mulai{" "}
                <span className="bg-gradient-to-r from-yellow-300 to-pink-300 bg-clip-text text-transparent">
                  Ramalan Anda
                </span>
              </h1>
              <p className="text-purple-200 text-sm sm:text-base">
                Masukkan informasi Anda untuk mendapatkan ramalan numerologi
              </p>
            </div>

            <form onSubmit={handleSubmit} className="space-y-6">
              <div className="space-y-2">
                <label className="text-white font-medium">Nama Lengkap</label>
                <input
                  type="text"
                  value={fullName}
                  onChange={(e) => setFullName(e.target.value)}
                  placeholder="Masukkan nama lengkap Anda"
                  className="w-full px-4 py-3 bg-white/5 border border-white/20 rounded-xl text-white placeholder:text-white/40 focus:ring-2 focus:ring-yellow-300"
                />
              </div>

              <div className="space-y-2">
                <label className="text-white font-medium">Tanggal Lahir</label>
                <input
                  type="date"
                  value={birthDate}
                  onChange={(e) => setBirthDate(e.target.value)}
                  max={new Date().toISOString().split("T")[0]}
                  className="w-full px-4 py-3 bg-white/5 border border-white/20 rounded-xl text-white focus:ring-2 focus:ring-yellow-300"
                />
              </div>

              <button
                type="submit"
                className="w-full py-4 bg-gradient-to-r from-yellow-300 to-pink-400 text-purple-900 font-bold text-lg rounded-xl hover:scale-[1.02] transition-all flex items-center justify-center gap-2"
              >
                <Sparkles className="w-5 h-5" />
                Dapatkan Ramalan
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
